import { environment } from 'environments/environment.prod';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
// import 'core-js/es6/symbol';
// import 'core-js/es6/object';
// import 'core-js/es6/function';
// import 'core-js/es6/parse-int';
// import 'core-js/es6/parse-float';
// import 'core-js/es6/number';
// import 'core-js/es6/math';
// import 'core-js/es6/string';
// import 'core-js/es6/date';
// import 'core-js/es6/array';
// import 'core-js/es6/regexp';
// import 'core-js/es6/map';
// import 'core-js/es6/set';

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/** IE10 and IE11 requires the following to support `@angular/animation`. */
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.


/** Evergreen browsers require these. **/
import 'core-js/es6/reflect';
import 'core-js/es7/reflect';


/** ALL Firefox browsers require the following to support `@angular/animation`. **/
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.



/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js/dist/zone';  // Included with Angular CLI.
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import * as moment from 'moment';
import { isDefined } from '@ng-bootstrap/ng-bootstrap/util/util';
import { isNullOrUndefined } from 'util';

// FIXME: Mannaggia a quelli di FUSE.JS!
// La ricerca funzione e spaccano tutto per una
// semplice istruzione di debug! -.-" 
// Così, mi devo scrivere un polyfill che mi
// silenzi gli errori e mi eviti l'eccezione 
(function() {
	const stringify = JSON.stringify.bind(JSON);
	JSON.stringify = (...args: any[]) => {
		try {
			return stringify(...args);
		} catch (e) {
			if (!environment.production) {
				console.error(e);
			}
			return null;
		}
	};
	
})();

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.
/**
 * Need to import at least one locale-data with intl.
 */
// import 'intl/locale-data/jsonp/en'; 

Array.range = (sizeOrIndex: number, size?: number) => {
	let start = isNullOrUndefined(size) ? 0 : sizeOrIndex,
		length = isNullOrUndefined(size) ? sizeOrIndex : size;
	return Array.from({ length }, (value, key) => key + start);
}

NgbDate.prototype.toMoment = function() {
	return moment.utc({
		year: this.year,
		month: this.month - 1,
		day: this.day
	});
};

window.delete_cookie = function delete_cookie( ...names: string[] ) {
	for(let name of names) {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	}
}


// WEBPACK FOOTER //
// ./src/polyfills.ts